import { render, staticRenderFns } from "./TreeItem.vue?vue&type=template&id=fb8b4e16&scoped=true"
import script from "./TreeItem.vue?vue&type=script&lang=js"
export * from "./TreeItem.vue?vue&type=script&lang=js"
import style0 from "./TreeItem.vue?vue&type=style&index=0&id=fb8b4e16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb8b4e16",
  null
  
)

export default component.exports